import { useState } from "react";
import { UserPlus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ContactCreateSheet } from "../contacts/ContactCreateSheet";

// Sprint 10.x — Bouton "Ajouter contact rapide" pour le Dashboard et autres
// emplacements en dehors de /contacts. Réutilise ContactCreateSheet existant.
// Cf questionnaire Théo §5.1 — bouton doit être présent sur Dashboard ET
// sur l'onglet Contact.

export function QuickAddContactButton({
  variant = "default",
}: {
  variant?: "default" | "outline";
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        size="sm"
        variant={variant}
        onClick={() => setOpen(true)}
        className="gap-1.5"
      >
        <UserPlus className="size-3.5" />
        Ajouter contact rapide
      </Button>
      <ContactCreateSheet open={open} onOpenChange={setOpen} />
    </>
  );
}
